module.exports = __webpack_public_path__ + "img/home_city_icon3.2f57bd3.png";